export default __webpack_public_path__ + "static/media/home-smallBanner.c4af5d73.png";